import collectorEnUS from "./en-US/collector.json";
import reportsEnUS from "./en-US/reports.json";
import trustedOperatorEnUS from "./en-US/trustedOperator.json";
import companyAdminEnUS from "./en-US/companyAdmin.json";
import platformAdminEnUS from "./en-US/platformAdmin.json";
import collectorEsAR from "./es-AR/collector.json";
import reportsEsAR from "./es-AR/reports.json";
import trustedOperatorEsAR from "./es-AR/trustedOperator.json";
import companyAdminEsAR from "./es-AR/companyAdmin.json";
import platformAdminEsAR from "./es-AR/platformAdmin.json";
import { HELP_PERSONAS } from "../personas";

const FALLBACK_LOCALE = "en-US";

const HELP_CONTENT = Object.freeze({
  "en-US": Object.freeze({
    [HELP_PERSONAS.COLLECTOR]: collectorEnUS,
    [HELP_PERSONAS.REPORTS]: reportsEnUS,
    [HELP_PERSONAS.TRUSTED_OPERATOR]: trustedOperatorEnUS,
    [HELP_PERSONAS.COMPANY_ADMIN]: companyAdminEnUS,
    [HELP_PERSONAS.PLATFORM_ADMIN]: platformAdminEnUS,
  }),
  "es-AR": Object.freeze({
    [HELP_PERSONAS.COLLECTOR]: collectorEsAR,
    [HELP_PERSONAS.REPORTS]: reportsEsAR,
    [HELP_PERSONAS.TRUSTED_OPERATOR]: trustedOperatorEsAR,
    [HELP_PERSONAS.COMPANY_ADMIN]: companyAdminEsAR,
    [HELP_PERSONAS.PLATFORM_ADMIN]: platformAdminEsAR,
  }),
});

export function normalizeHelpLocale(locale) {
  if (!locale) {
    return FALLBACK_LOCALE;
  }
  if (HELP_CONTENT[locale]) {
    return locale;
  }
  const base = String(locale).split("-")[0].toLowerCase();
  if (base === "es") {
    return "es-AR";
  }
  if (base === "en") {
    return "en-US";
  }
  return FALLBACK_LOCALE;
}

export function getHelpContent(locale, persona) {
  const normalizedLocale = normalizeHelpLocale(locale);
  const localeContent = HELP_CONTENT[normalizedLocale] || HELP_CONTENT[FALLBACK_LOCALE];
  return (
    localeContent?.[persona] ||
    localeContent?.[HELP_PERSONAS.COLLECTOR] ||
    HELP_CONTENT[FALLBACK_LOCALE][HELP_PERSONAS.COLLECTOR]
  );
}
